import "/Users/caldis/Code/react-zmage/packages/core/src/components/Browser/Browser.module.less?css";
export default {"wrapperLayer":"wrapperLayer__Br2mJ"};